import React from 'react';
import styled, { css } from 'styled-components';
import { palette } from 'theme';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import PaddedDivider from 'components/PaddedDivider';
import CircleIcon from 'mdi-material-ui/Circle';

export const MetaWrapper = styled.div`
  flex-wrap: wrap;
  margin: ${props => `${props.spacing || 0}px 0`};
  display: flex;
  justify-content: ${props => props.justify};
`;

export const MetaTypography = styled(({ divided, ...other }) => (
  <Typography variant="overline" {...other} />
))`
  opacity: 0.65;
  display: inline-block;
  ${props =>
    props.divided &&
    css`
      &:not(:last-child):after {
        content: '•';
        display: inline-block;
        margin: 0 10px;
      }
    `}
`;

export const MetaTypographyLink = styled(MetaTypography)`
  opacity: 1;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const BlogCategories = ({ categories, ...other }) =>
  categories && categories.length > 0 ? (
    <span {...other}>
      {categories.map(cat => (
        <MetaTypographyLink
          component={Link}
          to={`/blog/category/${cat.slug}`}
          key={cat.slug}
          divided
        >
          {cat.title}
        </MetaTypographyLink>
      ))}
    </span>
  ) : null;

export const ReadingTime = ({ wordCount, ...other }) =>
  wordCount ? (
    <MetaTypography {...other}>
      {Math.ceil(wordCount / 200)} min read
    </MetaTypography>
  ) : null;

export const AuthorList = ({ authors, ...other }) =>
  authors && authors.length > 0 ? (
    <MetaTypography {...other}>
      {authors[0].name} {authors.length > 1 && 'Et al.'}
    </MetaTypography>
  ) : null;

const TagTypography = styled(Typography)`
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  margin: 5px 5px 5px 10px;
  img {
    height: 24px;
    margin-right: 8px;
    width: auto;
  }
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  &:not(:last-child):after {
    content: '';
  }
`;

const TagListItem = styled(({ label, slug, items, ...other }) =>
  items && items.length > 0 ? (
    <div {...other}>
      <Typography variant="overline" inline>
        {label}
      </Typography>
      {items.map(item => (
        <TagTypography
          variant="subtitle2"
          key={item.slug}
          component={Link}
          to={`/blog/tag/${slug}/${item.slug}`}
        >
          {item.icon ? (
            <img src={item.icon.url} alt={item.title} />
          ) : (
            <CircleIcon />
          )}
          {item.title}
        </TagTypography>
      ))}
    </div>
  ) : null
)`
  padding: 0;
  display: flex;
  align-items: center;

  svg {
    fill: ${palette.grey[100]};
    width: 8px;
    height: 8px;
    margin: 0 10px 0 0;
  }
`;

export const TagList = ({ categoriesTags, ...rest }) =>
  _.some(_.map(categoriesTags, value => value.length > 0)) ? (
    <div {...rest}>
      <TagListItem
        label="Product Used"
        slug="product"
        items={_.get(categoriesTags, 'product')}
      />
      <TagListItem
        label="Application"
        slug="application"
        items={_.get(categoriesTags, 'application')}
      />
      <TagListItem
        label="Research Area"
        slug="research-area"
        items={_.get(categoriesTags, 'research_area')}
      />
      <TagListItem
        label="Editing Method"
        slug="editing-method"
        items={_.get(categoriesTags, 'editing_method')}
      />
      <TagListItem
        label="Model Organism"
        slug="model-organism"
        items={_.get(categoriesTags, 'model_organism')}
      />
      <TagListItem
        label="Paper Type"
        slug="paper-type"
        items={_.get(categoriesTags, 'paper_type')}
      />
      <PaddedDivider />
    </div>
  ) : null;
